export default "__VITE_PUBLIC_ASSET__aad526b9__"